// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qriJrCOuF9UB9hjRUsnC{text-decoration:none;height:32px}`, "",{"version":3,"sources":["webpack://./src/widgets/ContactsDetails/ui/ContactsIntegrations/ui/ReconnectButton/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,oBAAA,CACA,WAAA","sourcesContent":[".reconnectButton {\n  text-decoration: none;\n  height: 32px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"reconnectButton": `qriJrCOuF9UB9hjRUsnC`
};
export default ___CSS_LOADER_EXPORT___;
